import { httpClient, mountUrl } from '@/httpClient'

const BASE_URL = '/api/v1/sites'
const SITE_URL = '/api/v1/sites/$id'

export const findAll = ({ query = null, page = 1 } = {}) => httpClient.get(BASE_URL, {
  params: {
    addressMatches: query,
    page
  }
})

export const find = ({ id }) => httpClient.get(mountUrl(SITE_URL, { id }))
